<template>
  <div>
    <section class="hero is-info is-bold">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            <i class="fa fa-bar-chart"></i>&nbsp;&nbsp;Representatives
          </h1>
          <h2 class="subtitle">
            Representatives are accounts which cast votes in the case of a fork in the network. Learn more about representatives in the docs.
          </h2>
        </div>
      </div>
    </section>
    <div class="section">
      <div class="container">
        <div class="content">
          <!-- decentralize -->
          <section>
            <div class="notification is-light">
              <div class="container">
                <span class="has-text-weight-bold">{{ $t("res.slogan", {coin: this.$CoinName}) }}</span>
                <span>{{ $t("res.slogan_address", {coin: this.$CoinName}) }}</span>
                <code class="has-background-light is-size-5">29ddee7880d6dd82324674776cae452c3cba13fd</code>
              </div>
            </div>
          </section>
          <!-- voting weight -->
          <h2>Voting Weight Distribution</h2>
          <live-tag/>
          <h2>
            TODO: add representative information here
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LiveTag from '../components/layout/LiveTag'
export default {
    name: 'Representatives',
    components: {LiveTag}
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Representatives.vue